import React from 'react'
import { Button } from 'hljd'
import {
  AGREE_JOIN_GROUP,
  REFUSE_JOIN_GROUP,
  SIYI_INVITE_AGREE,
  SIYI_INVITE_REFUSE,
  SIYI_INVITE_INVALID
} from '@components/LocalMerchant/SiDa/constant'
import { Flex } from 'hljd'
import Img from '@UI/Img'
import { goToSiYiTeamHome } from '@components/LocalMerchant/SiDa/util'

export default store => [
  {
    title: '',
    dataIndex: ['group', 'name'],
    render: (name, { group }) => {
      group = group || {}

      return (
        <Flex
          vc
          style={{ cursor: 'pointer' }}
          onClick={() => goToSiYiTeamHome(group.id)}
        >
          <Img
            src={group.logoPath}
            style={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              marginRight: 15
            }}
          />
          <div>{name}</div>
        </Flex>
      )
    }
  },
  {
    title: '操作',
    dataIndex: 'id',
    render: (id, { status }) => {
      let element = null

      if (status == SIYI_INVITE_AGREE) {
        element = '已加入'
      }

      if (status == SIYI_INVITE_REFUSE) {
        element = '已拒绝'
      }

      if (status == SIYI_INVITE_INVALID) {
        element = '已失效'
      }

      return (
        <Flex style={{ justifyContent: 'flex-end' }}>
          {element || (
            <>
              <Button
                type="danger"
                ghost={true}
                onClick={() => store.agreeJoinGroup(id, REFUSE_JOIN_GROUP)}
                style={{ marginRight: 10 }}
              >
                拒绝
              </Button>

              <Button
                onClick={() => store.agreeJoinGroup(id, AGREE_JOIN_GROUP)}
              >
                同意
              </Button>
            </>
          )}
        </Flex>
      )
    }
  }
]
